module.exports = {"410223001":"两湖街道","410223101":"洧川镇","410223102":"朱曲镇","410223103":"蔡庄镇","410223104":"永兴镇","410223105":"张市镇","410223106":"十八里镇","410223107":"水坡镇","410223108":"大营镇","410223109":"庄头镇","410223200":"邢庄乡","410223203":"大马乡","410223204":"岗李乡","410223205":"门楼任乡","410223206":"大桥乡","410223207":"南曹乡","410223208":"小陈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410223.json
// module id = 1655
// module chunks = 0